import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { UtilService } from '@app/utility/util.service'
import { ApiService } from '@app/utility/api.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var $: any

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  config: any
  chatbotUrl: SafeResourceUrl
  urlString: ""

  cookieData: any

  constructor(
    private router: Router,
    private util: UtilService,
    private api: ApiService,
    private sanitizer: DomSanitizer
  ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))

    this.config = await this.api.get("master", "configuration")
    if(this.config == null || this.config.length == 0){

    }

    let chatbotConfig: any = this.config.filter((c: any) => {
      return c.dpa_name.toUpperCase() == "CHATBOT"
    })

    if(chatbotConfig == null || chatbotConfig.length == 0){
      this.util.ErrorDialog("ไม่สามารถดึงค่า Config ได้ กรุณาติดต่อเจ้าหน้าที่")
    }
    else{
      this.urlString = chatbotConfig[0].dpa_value
      this.chatbotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(chatbotConfig[0].dpa_value)
    }

    this.util.ShowWaiting(false)
  }

  newContact(event: any) {
    const url = this.util.baseUrl() + `/newCaseChatbot`
    window.open(url, '_blank');
  }

  newTab(){
    window.open(this.urlString, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.ts